var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUploadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 74,
    viewBox: "0 0 90 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 37V72",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8111 62C81.6234 59.9267 84.6351 56.6459 86.3707 52.6754C88.1064 48.705 88.4671 44.271 87.3961 40.0733C86.3251 35.8756 83.8833 32.1532 80.456 29.4936C77.0288 26.8341 72.8113 25.3888 68.4692 25.386H63.5442C62.3611 20.8209 60.156 16.5827 57.0946 12.9902C54.0333 9.39765 50.1953 6.54417 45.8694 4.64428C41.5434 2.7444 36.842 1.84754 32.1185 2.02115C27.3951 2.19476 22.7725 3.43431 18.5985 5.64662C14.4244 7.85892 10.8073 10.9864 8.01926 14.794C5.23121 18.6015 3.34469 22.99 2.50153 27.6296C1.65838 32.2691 1.88054 37.039 3.1513 41.5806C4.42205 46.1222 6.70835 50.3173 9.8383 53.8506",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61 53L45 37L29 53",
    stroke: "#C4C4C4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadingIcon);
export default __webpack_public_path__ + "static/media/FileUploadingIcon.a03a4691ca8f46c3b1d7337a40de7c86.svg";
export { ForwardRef as ReactComponent };